'use client';

import { useState, useEffect, useRef } from 'react';
import { useTranslations } from 'next-intl';

import { uiService } from '@/services/ui.service';

export const BookingFeatureTip = () => {
	const t = useTranslations('General');
	const [isShow, setIsShow] = useState(false);
	const timerRef = useRef<ReturnType<typeof setTimeout>>();

	useEffect(() => {
		const subscription = uiService.onDisplayBookingFeatureTip$.subscribe(() => {
			setIsShow(true);
			clearTimeout(timerRef.current);
			timerRef.current = setTimeout(
				() => {
					setIsShow(false);
				}, 
				3000
			);
		});

		return () => {
			clearTimeout(timerRef.current);
			subscription.unsubscribe();
		};
	}, []);

	return isShow ? (
		<div 
			className="tip tip--promo tip--top-right" 
			data-open="true"
		>
			<div className="scrollbar scrollbar--tip">
				<div className="tip__content">{t('lbl_ECPBookedHint')}</div>
			</div>
		</div>
	) : null;
};